var _a, _b, _c;
import { __decorate, __metadata } from "tslib";
import { Component, Prop, Ref, Watch, Mixins } from 'vue-property-decorator';
import { Form, Input, FormItem, Col, Row, Button } from 'element-ui';
import { E_MobileVerifyCodePurpose } from 'library-components/apis/passport/types';
import { getPublicKeyApi, postMobileVerifyCodeApi } from 'library-components/apis/login/login';
import JSEncrypt from 'jsencrypt';
import { get, indexOf } from 'lodash';
import { getAlertDataByCode } from 'library-components/config/alertMsg';
import { Toast } from 'patsnap-biz';
import { getMobileVerifyCodeCountDownTime, getUserAccountMobileNumber, setAccountCountryCode, setMobileVerifyCodeCountDownTime, setUserAccountMobileNumber } from 'library-components/services/localStorage';
import { CLOSE } from 'library-components/apis/passport/error';
import { ReCaptchaVerificationMixin } from 'library-components/mixins/reCaptchaVerificationMixin';
import PtIcon from '@patsnap-biz/icon';
import '@patsnap-biz/icon/lib/style';
import '@patsnap-ui/icon/assets/solid/DropdownOpen.svg';
function makeFormSms() {
    return {
        mobile_number: '',
        verify_code: '',
        country_code: '+86',
    };
}
let MobileVerifyCodeFormImpl = class MobileVerifyCodeFormImpl extends Mixins(ReCaptchaVerificationMixin) {
    constructor() {
        super(...arguments);
        this.isLoading = false;
        this.phoneCodes = [];
        this.formSms = makeFormSms();
        this.verificationCodeCountdown = 60;
        this.sendVerifyCodeBtnText = this.$t('passport.send_code');
        this.verificationCodeCountdownInterval = null;
    }
    OnMobilePropChange(value) {
        this.formSms.mobile_number = value;
    }
    OnCountryCodePropChange(value) {
        this.formSms.country_code = value;
    }
    // 监听select 记住上次选择的country_code
    countryCodeSelectChange() {
        setAccountCountryCode(this.formSms.country_code, this.purpose);
    }
    get smsRules() {
        return this.rules || {
            mobile_number: [
                { required: true, trigger: 'click', message: ' ' },
                { min: 11, trigger: 'click', message: this.$t('passport.mobileError') }
            ],
            verify_code: [
                { required: true, trigger: 'click', message: ' ' }
            ],
        };
    }
    onMobileNumberKeyupEnter() {
        this.onSendMobileVerifyCode();
    }
    async onSendMobileVerifyCode() {
        if (this.canSendMobileVerifyCode) {
            if (this.isLoading)
                return;
            this.isLoading = true;
            const resGeetestValidate = await this.geetestValidate();
            if (resGeetestValidate === CLOSE) {
                this.isLoading = false;
                return;
            }
            this.sendMobileVerifyCode(resGeetestValidate);
        }
    }
    onVerifyCodeKeyupEnter() {
        const { mobile_number, verify_code } = this.formSms;
        if (mobile_number && verify_code) {
            this.submit();
        }
    }
    get canSendMobileVerifyCode() {
        const { mobile_number } = this.formSms;
        return mobile_number.length === 11 && this.verificationCodeCountdown === 60 && !this.isLoading;
    }
    get sendMobileVerifyCodeBtnText() {
        return this.verificationCodeCountdown === 60 ? this.sendVerifyCodeBtnText : `${this.verificationCodeCountdown}s`;
    }
    countDownInterValFun() {
        this.verificationCodeCountdownInterval = setInterval(() => {
            if (this.verificationCodeCountdown === 0) {
                clearInterval(this.verificationCodeCountdownInterval);
                this.verificationCodeCountdown = 60;
                this.sendVerifyCodeBtnText = this.$t('passport.personalInformation.resend');
                return;
            }
            this.verificationCodeCountdown--;
        }, 1000);
    }
    /**
     * 倒计时开始执行
     */
    countDownStart() {
        const { mobile_number, country_code } = this.formSms;
        this.countDownInterValFun();
        setMobileVerifyCodeCountDownTime(this.purpose);
        setUserAccountMobileNumber(mobile_number, this.purpose);
        setAccountCountryCode(country_code, this.purpose);
    }
    async sendMobileVerifyCode(resGeetestValidate) {
        const { mobile_number, country_code } = this.formSms;
        try {
            const publicKey = await getPublicKeyApi();
            const encrypt = new JSEncrypt({});
            encrypt.setPublicKey(publicKey);
            const encryptMobileNumber = encrypt.encrypt(mobile_number);
            await postMobileVerifyCodeApi({
                mobile_number: encryptMobileNumber,
                country_code,
                purpose: this.purpose,
                lang: this.$i18n.locale,
            }, resGeetestValidate);
            this.countDownStart();
            this.verifyCodeRef.focus();
            const { msg } = getAlertDataByCode({
                code: '20004',
                lang: this.$i18n.locale,
                userMobileNumber: mobile_number,
            });
            return Toast({
                type: 'success',
                message: msg,
                duration: 3000,
            });
        }
        catch (e) {
            let errorCode = get(e, 'response.data.errcode') || get(e, 'response.data.numeric_error_code');
            const status = get(e, 'response.status');
            if (status === 500) {
                // 服务器错误直接-1
                // passport服务错误中也有 `number_error_code`
                errorCode = -1;
            }
            const { msg } = getAlertDataByCode({
                code: errorCode,
                lang: this.$i18n.locale,
            });
            // 手机号不存在时，直接提示，验证码发送成功。
            if (errorCode === 30101 || errorCode === 30801) {
                const { msg } = getAlertDataByCode({
                    code: '30101.2',
                    lang: this.$i18n.locale,
                });
                return Toast({
                    type: 'error',
                    message: msg,
                    duration: 3000,
                    showClose: true,
                });
            }
            if (errorCode) {
                Toast({
                    message: msg,
                    type: 'error',
                    duration: 3000,
                    showClose: true,
                });
            }
        }
        finally {
            this.isLoading = false;
        }
    }
    reset() {
        this.formRef.resetFields();
    }
    submit() {
        // if (this.isLoading) return
        this.formRef.validate(valid => {
            if (!valid) {
                this.isLoading = false;
                this.$emit('validateFail');
                return;
            }
            this.$emit('submit', this.formSms);
        });
    }
    async created() {
        this.formSms = makeFormSms();
        // 如果是手机号绑定，且为添加手机号功能
        if (indexOf([E_MobileVerifyCodePurpose.MOBILE_NUMBER_BINDING, E_MobileVerifyCodePurpose.PASSWORD_FORGOT], this.purpose) > -1 && !this.mobile) {
            this.formSms.mobile_number = '';
        }
        else {
            this.formSms.mobile_number = this.mobile || getUserAccountMobileNumber(this.purpose) || '';
        }
        const countDownTime = getMobileVerifyCodeCountDownTime(this.purpose);
        const nowTime = new Date().getTime();
        if (countDownTime) {
            const countDownNumber = 60 - parseInt(((nowTime - countDownTime) / 1000).toString());
            if (countDownNumber <= 0)
                return;
            // 倒计时中需要试用缓存中的手机号
            this.formSms.mobile_number = getUserAccountMobileNumber(this.purpose) || '';
            this.verificationCodeCountdown = countDownNumber;
            this.countDownInterValFun();
        }
        this.formSms.country_code = '+86';
    }
    mounted() {
    }
};
__decorate([
    Prop({
        type: String,
        default: E_MobileVerifyCodePurpose.LOGIN,
    }),
    __metadata("design:type", typeof (_a = typeof E_MobileVerifyCodePurpose !== "undefined" && E_MobileVerifyCodePurpose) === "function" ? _a : Object)
], MobileVerifyCodeFormImpl.prototype, "purpose", void 0);
__decorate([
    Prop({
        type: String,
        default: '',
    }),
    __metadata("design:type", String)
], MobileVerifyCodeFormImpl.prototype, "mobile", void 0);
__decorate([
    Prop({
        type: Object,
    }),
    __metadata("design:type", Object)
], MobileVerifyCodeFormImpl.prototype, "rules", void 0);
__decorate([
    Prop({
        type: Boolean,
        default: true,
    }),
    __metadata("design:type", Boolean)
], MobileVerifyCodeFormImpl.prototype, "canModifyMobile", void 0);
__decorate([
    Prop({
        type: String,
        default: '',
    }),
    __metadata("design:type", String)
], MobileVerifyCodeFormImpl.prototype, "countryCode", void 0);
__decorate([
    Prop({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", String)
], MobileVerifyCodeFormImpl.prototype, "needCountryCode", void 0);
__decorate([
    Ref(),
    __metadata("design:type", typeof (_b = typeof Form !== "undefined" && Form) === "function" ? _b : Object)
], MobileVerifyCodeFormImpl.prototype, "formRef", void 0);
__decorate([
    Ref(),
    __metadata("design:type", typeof (_c = typeof Input !== "undefined" && Input) === "function" ? _c : Object)
], MobileVerifyCodeFormImpl.prototype, "verifyCodeRef", void 0);
__decorate([
    Watch('mobile'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MobileVerifyCodeFormImpl.prototype, "OnMobilePropChange", null);
__decorate([
    Watch('countryCode'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MobileVerifyCodeFormImpl.prototype, "OnCountryCodePropChange", null);
MobileVerifyCodeFormImpl = __decorate([
    Component({
        name: 'MobileVerifyCodeForm',
        components: {
            'el-form': Form,
            'el-form-item': FormItem,
            'el-input': Input,
            'el-col': Col,
            'el-row': Row,
            'el-button': Button,
            PtIcon,
        },
    })
], MobileVerifyCodeFormImpl);
export { MobileVerifyCodeFormImpl };
